import { Component, Inject } from '@angular/core';


@Component({
    selector: 'dhi-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'candidate-tool-password-confirm';


    constructor() {}

}
